import 'react';
import { Helmet } from 'react-helmet';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const getUrls = typography => {
  if (typography.gwfUrl != null && typography.gwfUrl !== '') {
    return [typography.gwfUrl];
  }
  return [typography.contentURL, typography.displayURL].filter(url => url != null);
};
const TypographyImporter = _ref => {
  let {
    children,
    typography
  } = _ref;
  const urls = getUrls(typography).filter(url => url != null);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Helmet, {
      children: urls.map(url => /*#__PURE__*/jsx("link", {
        href: url,
        rel: "stylesheet",
        crossOrigin: "anonymous"
      }, url))
    }), children]
  });
};
TypographyImporter.displayName = 'TypographyImporter';
var TypographyImporter$1 = TypographyImporter;

export { TypographyImporter$1 as default };
